import { LoadingPage } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 1);
`

const Loading = ({ active }: { active: boolean }) => {
  if (!active) {
    return null
  }

  return (
    <LoadingOverlay>
      <LoadingPage />
    </LoadingOverlay>
  )
}

export default Loading
